import * as UserQueries from './Users'
import * as GroupQueries from './Group'
import * as MessageQueries from './Messages'

export const User = UserQueries
export const Group = GroupQueries
export const Message = MessageQueries